export default "__VITE_ASSET__CNPB0e0p__"